"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTtsUrl = exports.getStartedCmsUrlPublic = exports.getPublicSiteDomain = exports.getBundledOffer = exports.getGAClassName = exports.getHubsSignupCTA = exports.getHubsSignupUrl = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var MerchIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var _Editions = require("self-service-api/constants/Editions");

var _BundledOffers = require("pricing-pages-unified-ui/constants/BundledOffers");

var _NonMerchandiseIdProducts = require("pricing-pages-unified-ui/constants/NonMerchandiseIdProducts");

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _merchToSignupStringM;

// (may 8, 2019) cta documentation:
// https://docs.google.com/spreadsheets/d/1BHY9NGG6e41cna8s31RnxY1Sn0I7kNVBzzwuAxVd2D0/edit?ts=5cd1f219#gid=1017927284
// hubs_signup-url is added as a query param to any CTAs on the public pricing page  for the the marketing
// team's GA  tracking. New CTAs can be added just in a manner consistent to other ones, but we should be
// mindful of editing existing ones as it could break tracking and we should consult with web strategy first
var getHubsSignupUrl = function getHubsSignupUrl(_ref) {
  var products = _ref.products,
      merchandiseId = _ref.merchandiseId,
      nonMerchandiseIdProduct = _ref.nonMerchandiseIdProduct;
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "" + window.location.hostname + window.location.pathname;
  // Strip query params from this URL
  var url = encodeURI(baseUrl.split('?')[0]);

  if (merchandiseId) {
    var edition = products[merchandiseId].edition;
    var editionToAppend = [_Editions.FREE, _Editions.STARTER, _Editions.PROFESSIONAL, _Editions.ENTERPRISE].indexOf(edition) > -1 ? edition : undefined;

    if (editionToAppend) {
      url = url + "/" + edition;
    }
  } else if (nonMerchandiseIdProduct) {
    var _nonMerchProductToEdi;

    var nonMerchProductToEdition = (_nonMerchProductToEdi = {}, (0, _defineProperty2.default)(_nonMerchProductToEdi, _NonMerchandiseIdProducts.SUITE_STARTER, _Editions.STARTER), (0, _defineProperty2.default)(_nonMerchProductToEdi, _NonMerchandiseIdProducts.SUITE_STARTER_MC, _Editions.STARTER), (0, _defineProperty2.default)(_nonMerchProductToEdi, _NonMerchandiseIdProducts.SUITE_STARTER_COVID_MC, _Editions.STARTER), (0, _defineProperty2.default)(_nonMerchProductToEdi, _NonMerchandiseIdProducts.SUITE_PROFESSIONAL, _Editions.PROFESSIONAL), (0, _defineProperty2.default)(_nonMerchProductToEdi, _NonMerchandiseIdProducts.SUITE_ENTERPRISE, _Editions.ENTERPRISE), _nonMerchProductToEdi);
    var _edition = nonMerchProductToEdition[nonMerchandiseIdProduct];

    if (_edition) {
      url = url + "/" + _edition;
    }

    if (nonMerchandiseIdProduct === _NonMerchandiseIdProducts.BUNDLE) {
      // Pass whole url (including query params) for bundles
      url = encodeURI(baseUrl);
    }
  }

  return url;
};

exports.getHubsSignupUrl = getHubsSignupUrl;
var merchToSignupStringMap = (_merchToSignupStringM = {}, (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_CRM, 'crm'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_MARKETING_STARTER_NOV_2019, 'marketingstarter'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_MARKETING_STARTER_MC, 'marketingstarter'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_MARKETING_PROFESSIONAL, 'marketingpro'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_MARKETING_PROFESSIONAL_MC, 'marketingpro'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_MARKETING_ENTERPRISE, 'marketingenterprise'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_MARKETING_ENTERPRISE_MC, 'marketingenterprise'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_SALES_STARTER_MAR_2020, 'salesstarter'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019, 'salespro'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_SALES_ENTERPRISE, 'salesenterprise'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_SERVICE_STARTER_MAR_2020, 'servicestarter'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_SERVICE_PROFESSIONAL, 'serviceprofessional'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_SERVICE_ENTERPRISE, 'serviceenterprise'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_CMS_PROFESSIONAL, 'cmsprofessional'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.PRODUCT_CMS_ENTERPRISE, 'cmsenterprise'), (0, _defineProperty2.default)(_merchToSignupStringM, MerchIds.SERVICE_FIRST_TIME_FULL_MIGRATION, 'cmsmigrations'), _merchToSignupStringM); // hubs_signup-cta can be derived from sourceId and the
// merchId/nonMerchandiseIdProduct so we centralize it here
// rather than having each purchase motion explicitly define it

var getHubsSignupCTA = function getHubsSignupCTA(ctaType, // tts, buy, trial
sourceId, merchandiseId, nonMerchandiseIdProduct) {
  var resolvedProductIdentifier;
  var resolvedSourceIdentifier;

  if (!merchandiseId && !nonMerchandiseIdProduct) {
    throw new Error('need one of merchandiseId or nonMerchandiseIdProduct');
  }

  if (ctaType === 'buy') {
    var sourceParts = sourceId.split('-');
    resolvedSourceIdentifier = sourceParts[0] + "-buy" + sourceParts[1];
  } else if (ctaType === 'trial') {
    var _sourceParts = sourceId.split('-');

    resolvedSourceIdentifier = _sourceParts[0] + "-trial" + _sourceParts[1];
  } else {
    resolvedSourceIdentifier = sourceId;
  }

  if (merchandiseId) {
    resolvedProductIdentifier = merchToSignupStringMap[merchandiseId];

    if (!resolvedProductIdentifier) {
      throw new Error("unrecognized merchandiseId (" + merchandiseId + ") for hubs signup cta");
    }
  } else {
    resolvedProductIdentifier = nonMerchandiseIdProduct;
  }

  return resolvedProductIdentifier + "-" + resolvedSourceIdentifier;
}; // This function exists to simply wrap classNames so we are more aware that
// they are necessary for Google Analytics tracking and don't remove them accidentally


exports.getHubsSignupCTA = getHubsSignupCTA;

var getGAClassName = function getGAClassName(gaTrackingClassname) {
  return gaTrackingClassname;
};

exports.getGAClassName = getGAClassName;

var getBundledOffer = function getBundledOffer(merchId, promotion, nonMerchandiseIdProduct) {
  var promotionId = promotion && promotion.eligiblePromotion;

  if (promotionId && _BundledOffers.promotionalBundleOffers[promotionId]) {
    return _BundledOffers.promotionalBundleOffers[promotionId][merchId];
  }

  if (nonMerchandiseIdProduct) {
    return _BundledOffers.standardBundleOffers[nonMerchandiseIdProduct] || null;
  }

  return _BundledOffers.standardBundleOffers[merchId] || null;
}; // need to keep a check on this - not sure if will be accurate for all links


exports.getBundledOffer = getBundledOffer;

var getPublicSiteDomain = function getPublicSiteDomain() {
  var langMap = {
    en: "https://www.hubspot.com",
    de: "https://www.hubspot.de",
    es: "https://www.hubspot.es",
    pt: "https://br.hubspot.com",
    fr: "https://www.hubspot.fr",
    ja: "https://www.hubspot.jp"
  };
  return (0, _urls.langToUrl)(langMap);
};

exports.getPublicSiteDomain = getPublicSiteDomain;

var getStartedCmsUrlPublic = function getStartedCmsUrlPublic() {
  var publicSiteDomain = getPublicSiteDomain();
  return publicSiteDomain + "/products/marketing/content-management-system/get-started";
};

exports.getStartedCmsUrlPublic = getStartedCmsUrlPublic;

var getTtsUrl = function getTtsUrl() {
  var langMap = {
    en: 'https://offers.hubspot.com/contact-sales',
    de: 'https://offers.hubspot.de/contact-sales',
    es: 'https://offers.hubspot.es/contact-sales',
    pt: 'https://br.hubspot.com/ofertas/contact-sales',
    fr: 'https://offers.hubspot.fr/contact-sales',
    ja: 'https://offers.hubspot.jp/contact-sales'
  };
  return (0, _urls.langToUrl)(langMap);
};

exports.getTtsUrl = getTtsUrl;